module.exports = __webpack_public_path__ + "feature-request-tracking-3-08b96a9d5c0b93abf62ac008167782c0.webp";